import type { ComposeViewState } from "owa-mail-compose-store";
import { shouldDisableCompose } from "owa-mail-compose-store/lib/utils/shouldDisableCompose";

export default function canModifyRecipients(viewState: ComposeViewState): boolean {
    const { IRMData } = viewState.protectionViewState;
    const isReadonly = shouldDisableCompose(viewState);
    return (!IRMData || !!IRMData.IsOwner || !!IRMData.ForwardAllowed) && !isReadonly;
}
